import React from 'react';
import { connect, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Col, Row } from '@vds/grids';
import { Icon } from '@vds/icons';
import { ButtonIcon } from '@vds/button-icons';
import { Body } from '@vds/typography';
import { TextLink } from '@vds/buttons';
import QuickLinks from '../QuickLinks';
import {
  getAPPID,
  getUrlName,
  isWHW,
  isWHWP2,
  viewport,
  isMobileResolution,
  isECJointTransactionFlow,
  isACPEligibile,
  isVFEligibile,
  isDesktopResolutionViewPort,
  getCookie,
  getSession,
  getPageName,
} from '../Helpers';
import { miniCartBackHandler } from '../MiniCart/MiniCartUtils';
import { StyledHeaderRow, StyledHeaderTitle } from './MobileViewHeader.style';

const MobileViewHeader = (props) => {
  const dispatch = useDispatch();
  const { title, history, backIcon, dueTodayAmount, depletionType } = props;
  const currentPageName = getUrlName(window.location.pathname);
  const setupType = depletionType?.indexOf('O') > -1 ? 'Professional SetUp' : 'Self SetUp';
  const appId = getAPPID();
  const type = viewport();

  const { saveCartExpresscheckoutNSEFFlag, saveCartSuccessResponse } = props;
  const goBack = (e) => {
    e.preventDefault();

    if (type === 'mobile' || type === 'mfapp' || type === 'tablet') {
      miniCartBackHandler(currentPageName, appId, history, dueTodayAmount, setupType);
    } else {
      history.goBack();
    }
  };

  // if no title found then don't display header / navigation section
  if (!title) {
    return null;
  }

  const isMvaHeader = type === 'mfapp';
  const showSaveCart = !isACPEligibile() && !isVFEligibile();
  const isShowSaveCartLink = getSession('hideSaveCartSuccessLink');
  const isExpresscheckoutPage = getPageName() === 'expresscheckout';

  return (
    <Row className={`alignItemsCenter pad16 ${isMvaHeader && saveCartExpresscheckoutNSEFFlag ? 'flex-end' : 'justify-space-between'}`}>
      <Col>
        <StyledHeaderRow>
          {backIcon && !isMvaHeader && (
            <ButtonIcon
              fitToIcon
              data-testid="backArrowIcon"
              kind="ghost"
              size="small"
              onClick={(e) => goBack(e)}
              renderIcon={() => <Icon name="left-caret" size="large" />}
            />
          )}
          {!isMvaHeader && (
            <StyledHeaderTitle isMobileResolution={isMobileResolution()} showIcon={backIcon}>
              {title}
            </StyledHeaderTitle>
          )}
        </StyledHeaderRow>
      </Col>
      {saveCartExpresscheckoutNSEFFlag && isExpresscheckoutPage && !saveCartSuccessResponse && !isShowSaveCartLink && (
        <Col>
          <div className="saveCartsectionFlex linkSection">
            {showSaveCart && appId !== 'AAL' && (
              <div className="" style={{ display: 'inline-flex' }}>
                {!isDesktopResolutionViewPort() && (
                  <div className="pad10 onlyRightPad">
                    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M6.81111 9.22253L9.37778 12.1559V5.75586H10.6222V12.1336L13.2111 9.22253L14.1 10.1114L10 14.5559L5.92222 10.1114L6.81111 9.22253ZM20 2.75586V17.7559H0V0.255859H6.66667L8.88889 2.75586H20ZM18.7556 4.0003H8.23333L6.01111 1.5003H1.25556V16.5003H18.7556V4.0003Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                )}
                <Body size="large">
                  <TextLink
                    id="savecartButton"
                    data-testid="savecartButton"
                    role="button"
                    ariaLabel="Save Cart"
                    onClick={() => dispatch({ type: 'DISPLAY_SAVE_CART_SECTION', value: true })}
                    analyticstrack="5G-expandedProgressbar"
                    data-track='{"type" : "link", "name" : "save cart | expresscheckout","data":{"page":{ "subFlow":("eVar64","sc_p_ec")}}}'
                    tabIndex="0"
                    type="inline"
                    size="small"
                  >
                    Save cart
                  </TextLink>
                </Body>
              </div>
            )}
          </div>
        </Col>
      )}
      <Col>
        <QuickLinks hideLinks={window.vzFlags?.disableChatLinks} enableLiveSupport={!(isWHW() || isWHWP2()) && !isECJointTransactionFlow()} />
      </Col>
    </Row>
  );
};

MobileViewHeader.propTypes = {
  title: PropTypes.string,
  history: PropTypes.object,
  backIcon: PropTypes.bool,
  dueTodayAmount: PropTypes.string,
  depletionType: PropTypes.string,
  saveCartExpresscheckoutNSEFFlag: PropTypes.bool,
  saveCartSuccessResponse: PropTypes.bool,
};
const mapStateToProps = (state) => {
  const dueTodayAmount = state?.checkout?.orderDetails?.totalDueToday || 0;
  const depletionType = state?.checkout?.depletionType || '';
  const saveCartExpresscheckoutNSEFFlag =
    state?.checkout?.getCheckoutResponse?.data?.featureFlags?.saveCartExpresscheckoutNSEFFlag || getCookie('saveCartExpresscheckoutNSEFFlag');
  const saveCartSuccessResponse = state?.expressCheckout?.saveCartSuccessResponse;
  return { dueTodayAmount, depletionType, saveCartExpresscheckoutNSEFFlag, saveCartSuccessResponse };
};
export default connect(mapStateToProps)(MobileViewHeader);
